import React, { useEffect } from "react";
import { Button, Fab, TableBody, TableCell, TableRow, Typography, Grid } from '@mui/material';
import { FindInPage, ThumbUp, ThumbDown, QuestionMark } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const columns = [
    { id: 'rating', label: 'Rating' },
    { id: 'company_name', label: 'Company Name' },
    { id: 'mc', label: 'MC #' },
    { id: 'dot', label: 'DOT #' },
    { id: 'city', label: 'City' },
    { id: 'state', label: 'State' },
];

function SearchResultsTable({ toggleDrawer, dataFiltered, pageParent, rowsPerPageParent }) {
    const [page, setPage] = React.useState(pageParent);
    const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageParent);
    const [dataValue, setDataValue] = React.useState(dataFiltered);

    useEffect(() => {
        setDataValue(dataFiltered);
    }, [dataFiltered]);

    useEffect(() => {
        setPage(pageParent);
        setRowsPerPage(rowsPerPageParent)
    }, [pageParent, rowsPerPageParent]);


    const handleData = (data) => {
        toggleDrawer(true, data);
    }

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip placement="right" {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));


    return (
        <>
            <TableBody>
                {dataValue?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data) => {
                        return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={data.code}>
                                {columns.map((column) => {
                                    const value = data[column.id];
                                    return (
                                        <>
                                            {column.id === 'rating' ?
                                                (
                                                    <>
                                                        {(value === 'N') &&
                                                            <TableCell key={column.id} align={column.align}>
                                                                <HtmlTooltip
                                                                    title={
                                                                        <React.Fragment>
                                                                            <Typography style={{ color: '#FF0000', fontWeight: 'bold' }}>Negative Experience</Typography>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Button style={{ background: '#FF0000', color: 'white', borderRadius: '50%', height: '64px' }}>
                                                                        <ThumbDown />
                                                                    </Button></HtmlTooltip>
                                                            </TableCell>
                                                        }
                                                        {(value === 'B') &&
                                                            <TableCell key={column.id} align={column.align}>
                                                                <HtmlTooltip
                                                                    title={
                                                                        <React.Fragment>
                                                                            <Typography style={{ color: '#58A618', fontWeight: 'bold' }}>Positive Experience</Typography>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Button style={{ background: '#58A618', color: 'white', borderRadius: '50%', height: '64px' }}>
                                                                        <ThumbUp />
                                                                    </Button></HtmlTooltip>
                                                            </TableCell>
                                                        }
                                                        {(value === 'C') &&
                                                            <TableCell key={column.id} align={column.align}>
                                                                <HtmlTooltip
                                                                    title={
                                                                        <React.Fragment>
                                                                            <Typography style={{ color: '#FFAB00', fontWeight: 'bold' }}><QuestionMark /></Typography>
                                                                            {"Email us at creditinquiry@tabbank.com for more information."}
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Button style={{ background: '#FFAB00', color: 'white', borderRadius: '50%', height: '64px' }}>
                                                                        <QuestionMark />
                                                                    </Button>
                                                                </HtmlTooltip>
                                                            </TableCell>
                                                        }
                                                    </>
                                                )
                                                :
                                                (<TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number'
                                                        ? column.format(value)
                                                        : value}
                                                </TableCell>)
                                            }
                                        </>

                                    );
                                })}
                                <TableCell align={'center'}>
                                    <HtmlTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography style={{ color: '#1976D2', fontWeight: 'bold' }}>View Details</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button onClick={() => handleData(data)} style={{ background: '#1976D2', borderRadius: '50%', color: '#fff', height: '64px' }}>
                                            <FindInPage />
                                        </Button></HtmlTooltip>

                                </TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
        </>
    )
}

export default SearchResultsTable;